export default __webpack_public_path__ + "static/media/contact-us-wave-small.30703964.svg";